import {
  jb_listing_filter_css_default
} from "./chunk.5UZ4GSID.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-listing-filter/jb-listing-filter.ts
var JbListingFilter = class extends r {
  constructor() {
    super(...arguments);
    this.intranetStyle = false;
  }
  _handleFilterClick(event) {
    event.preventDefault();
    const newValue = event.target.dataset.filterValue;
    if (this.activeValue === newValue) {
      return;
    }
    this.activeValue = newValue;
    this.dispatchEvent(
      new CustomEvent("jb-listing-filter:change", {
        detail: {
          filterAspect: this.filterAspect,
          newValue
        },
        bubbles: true,
        composed: true
      })
    );
    this.requestUpdate();
  }
  render() {
    return ke`
      <ul class="${Rt({ intranet: this.intranetStyle, isSingleOption: this.options.length === 1 })}">
        ${this.options.length === 1 ? D : this.options.map(
      (option) => ke`<li class="${Rt({ active: option.value === this.activeValue })}">
                  <a
                    @click=${this._handleFilterClick}
                    data-filter-value=${option.value}
                    href="#"
                    >${option.label}</a
                  >
                </li>`
    )}
      </ul>
    `;
  }
};
JbListingFilter.styles = jb_listing_filter_css_default;
__decorateClass([
  n()
], JbListingFilter.prototype, "activeValue", 2);
__decorateClass([
  n()
], JbListingFilter.prototype, "filterAspect", 2);
__decorateClass([
  n({ type: Boolean })
], JbListingFilter.prototype, "intranetStyle", 2);
__decorateClass([
  n({ type: Array })
], JbListingFilter.prototype, "options", 2);
JbListingFilter = __decorateClass([
  customElement("jb-listing-filter")
], JbListingFilter);

export {
  JbListingFilter
};
